import React from 'react';
import logo from './logo-voala-25.png'

const LogoVoala = ({
  style = {},
  fill = '#FF5A00',
  width = 'auto',
  height = 'auto',
  className = '',
  viewBox = 'auto',
}) => (
  <img
    width={width}
    style={style}
    height={height}
    className={`svg-icon ${className || ''}`}
    src={logo}
  >
  </img>
);

export default LogoVoala;
